import { mutate } from "swr";

// SWR cache helpers for the MCP server entity, mirroring system-cache.ts. The
// list URL is the dedicated MCP entity endpoint (NOT /v1/system).
export const MCPS_LIST_URL = "/api/ai-transform/v1/mcp";

export function getMcpDetailUrl(serverId: string) {
  return `${MCPS_LIST_URL}?mcp_id=${encodeURIComponent(serverId)}`;
}

export function matchesMcpsCacheKey(key: unknown, expected: string) {
  if (typeof key === "string") return key === expected;
  if (Array.isArray(key) && typeof key[0] === "string") {
    return key[0] === expected;
  }
  return false;
}

export async function revalidateMcpsCache(serverId?: string) {
  await mutate((key) => matchesMcpsCacheKey(key, MCPS_LIST_URL));

  if (serverId) {
    await mutate((key) =>
      matchesMcpsCacheKey(key, getMcpDetailUrl(serverId)),
    );
  }
}
